const parseCertSubject = function(subject) {
    subject = subject.split(', ');
    return subject.reduce(function(acc, el) {
        var res = el.split('=');
        acc[res[0]] = res[1];
        return acc;
    }, {});
};

const getRandomStr = function() {
    return Array(20).join((Math.random().toString(36) + '00000000000000000').slice(2, 18)).slice(0, 19);
};

const formatInn = function(inn) {
    if (inn.length === 12 && inn.slice(0, 2) === '00') {
        return inn.slice(2, 12);
    }
    return inn;
}

function promiseRequest(options) {
	return new Promise(function (resolve, reject) {
		$.ajax(
			Object.assign({}, options, {
				success: function (response) {
					if (response.success) {
						resolve(response.data);
					}
					if (response.errors) {
						reject(response.errors);
					}
				},
				error: function () {
					reject(
						'При загрузке данных произошла ошибка. Повторите попытку позже'
					);
				},
			})
		);
	});
}

export { parseCertSubject, getRandomStr, formatInn, promiseRequest };
